<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_acc_package_type.edit_title')">
    <template #content>
      <v-container fluid class="edit-package-type" v-if="packageType">
        <v-form v-model="isFormValid"
                ref="editPackageTypeForm">
          <v-row>
            <v-col>
<!--              <v-row>-->
<!--                <v-col>-->
<!--                  <v-text-field readonly-->
<!--                                :label="$t('admin_acc_package_type.link')"-->
<!--                                :value="packageLink">-->
<!--                    <template #append>-->
<!--                      <v-tooltip top>-->
<!--                        <template #activator="{on, attrs}">-->
<!--                          <v-btn icon-->
<!--                                 x-small-->
<!--                                 v-on="on"-->
<!--                                 v-bind="attrs"-->
<!--                                 v-clipboard:copy="packageLink">-->
<!--                            <v-icon>fas fa-clipboard</v-icon>-->
<!--                          </v-btn>-->
<!--                        </template>-->
<!--                        <span>{{ $t('copy') }}</span>-->
<!--                      </v-tooltip>-->
<!--                    </template>-->
<!--                  </v-text-field>-->
<!--                </v-col>-->
<!--              </v-row>-->
              <v-row>
                <v-col>
                  <v-text-field outlined
                                :label="$t('admin_acc_package_type.name_en')"
                                v-model="packageType.name_en"
                                :rules="requiredRules"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field outlined
                                :label="$t('admin_acc_package_type.name_zh')"
                                v-model="packageType.name_zh"
                                :rules="requiredRules"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field outlined
                                :label="$t('admin_acc_package_type.price')"
                                v-model="packageType.price"
                                :rules="requiredRules"
                                type="number"
                                min="0"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-input :rules="requiredRules"
                           v-model="packageType.valid_from">
                    <v-container fluid class="flex-column pa-0">
                      <legend class="v-label theme--light">{{ $t('admin_acc_package_type.valid_from') }}</legend>
                      <DateTimePickerInput v-model="packageType.valid_from"
                                           hide-details></DateTimePickerInput>
                    </v-container>
                  </v-input>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-input :rules="validUntilRules"
                           v-model="packageType.valid_until">
                    <v-container fluid class="flex-column pa-0">
                      <legend class="v-label theme--light">{{ $t('admin_acc_package_type.valid_until') }}</legend>
                      <DateTimePickerInput v-model="packageType.valid_until"
                                           hide-details></DateTimePickerInput>
                    </v-container>
                  </v-input>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-input hide-details="auto"
                           v-model="packageType.banner"
                           :rules="requiredRules">
                    <v-container fluid class="flex-column">
                      <legend class="v-label theme--light">{{ $t('admin_acc_package_type.banner') }}</legend>
                      <PhotoPreviewInput v-model="packageType.banner"
                                         div-class="package-type-banner"
                                         file-name="package-type-banner"></PhotoPreviewInput>
                      <small class="form-text text-muted">ACCEPTED FILE FORMAT: PNG, JPEG, JPG; RECOMMENDED SIZE: <b>2545px(W) X 1081px(H)</b></small>
                    </v-container>
                  </v-input>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field outlined
                                :label="$t('admin_acc_package_type.description_en')"
                                v-model="packageType.description_en"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field outlined
                                :label="$t('admin_acc_package_type.description_zh')"
                                v-model="packageType.description_zh"></v-text-field>
                </v-col>
              </v-row>
<!--              <v-row class="pt-0">-->
<!--                <v-col>-->
<!--                  <v-input hide-details="auto"-->
<!--                           v-model="packageType.description_en">-->
<!--                    <v-container fluid class="flex-column pa-0">-->
<!--                      <legend class="v-label theme&#45;&#45;light">{{ $t('admin_acc_package_type.description_en') }}</legend>-->
<!--                      <TinyMceEditor v-model="packageType.description_en"></TinyMceEditor>-->
<!--                    </v-container>-->
<!--                  </v-input>-->
<!--                </v-col>-->
<!--              </v-row>-->
<!--              <v-row class="pt-0">-->
<!--                <v-col>-->
<!--                  <v-input hide-details="auto"-->
<!--                           v-model="packageType.description_zh">-->
<!--                    <v-container fluid class="flex-column pa-0">-->
<!--                      <legend class="v-label theme&#45;&#45;light">{{ $t('admin_acc_package_type.description_zh') }}</legend>-->
<!--                      <TinyMceEditor v-model="packageType.description_zh"></TinyMceEditor>-->
<!--                    </v-container>-->
<!--                  </v-input>-->
<!--                </v-col>-->
<!--              </v-row>-->
            </v-col>
            <v-col class="pa-0">
              <PackageContentList v-model="content"
                                  v-if="shown"></PackageContentList>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </template>

    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               class="ml-4"
               depressed
               large
               @click="$refs.editPackageTypeForm.validate() && save()">
          {{ $t('save') }}
          <v-icon right>fas fa-check</v-icon>
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>

<script>
import {computed, ref, watch} from "@vue/composition-api";
import BGModal from "@/components/BGModal";
import DateTimePickerInput from "@/components/DateTimePickerInput";
import PackageContentList from "@/components/package/PackageContentList";
import TinyMceEditor from "@/components/TinyMceEditor";
import PhotoPreviewInput from "@/components/PhotoPreviewInput";

export default {
  name: 'EditPackageTypeModal',
  components: {PhotoPreviewInput, TinyMceEditor, PackageContentList, DateTimePickerInput, BGModal},
  props: {
    packageTypeId: String,
    shown: Boolean,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    // Init
    watch(() => props.shown, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          packageType.value = {};
          content.value = [];

          getPackageType();
        }
      }
    });
    const cancel = function () {
      emit('cancel');
    };

    // Form
    const isFormValid = ref(false);
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const packageType = ref({});
    const getPackageType = function () {
      root.$callAPI('aafb/admin/package/type/', {type_id: props.packageTypeId}, (response) => {
        packageType.value = response.body.package_type;

        content.value = JSON.parse(response.body.package_type.content);
      });
    };
    const packageLink = computed(() => {
      if (!packageType.value) return;

      return window.location.protocol + "//" + window.location.hostname + "/" +
          root.$router.resolve({name: 'package-detail', params: {packageId: props.packageTypeId}}).href;
    })

    const validUntilRules = ref([
      ...requiredRules.value,
      value => (!packageType.value.valid_from || value > packageType.value.valid_from) || root.$t('admin_acc_package_type.invalid_valid_until'),
    ])

    const content = ref([]);

    const save = async function () {
      root.$callAPI('aafb/admin/package/type/set/', {
        ...packageType.value,
        type_id: props.packageTypeId,
        banner: packageType.value.banner instanceof File ? await root.$convertFileToBase64(packageType.value.banner) : packageType.value.banner,
        content: JSON.stringify(content.value),
      }, (response) => {
        emit('finish', response.body.package_type);
      });
    }

    return {
      dialogShown,
      cancel,

      isFormValid,
      requiredRules,

      packageType,
      packageLink,
      validUntilRules,

      content,

      save,
    }
  },
}
</script>

<style lang="less">
.edit-package-type {
  height: 100%;
  display: flex;
  flex-direction: column;

  .v-form {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}
</style>
